import React, { createContext, useMemo, useState, useEffect } from "react";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import GlobalStyles from '@mui/material/GlobalStyles';

// Create a context for toggling the color mode
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
});

const ThemeProvider = ({ children }) => {
  // Load theme from localStorage or default to 'light'
  const storedMode = localStorage.getItem("theme") || "light";
  const [mode, setMode] = useState(storedMode);

  useEffect(() => {
    // Save the theme mode in localStorage whenever it changes
    localStorage.setItem("theme", mode);
  }, [mode]);

  // Function to toggle between light and dark modes
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode(prevMode => (prevMode === "dark" ? "light" : "dark"));
      },
    }),
    []
  );

  // Create the theme based on the current mode
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: mode,
          common: {
            white: "#F8F8F8",
            black: "#2A2828",
          },
          primary: {
            main: "#eab308",
            contrastText: "#2A2828",
          },
          // background: {
          //   default: mode === "dark" ? "#121212" : "#F8F8F8",
          // },
        },
        
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <MuiThemeProvider theme={theme}>
        <GlobalStyles styles={{
          "html, body, #root": {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            transition: 'background-color 0.5s ease, color 0.5s ease',
          },
        }} />
        {children}
      </MuiThemeProvider>
    </ColorModeContext.Provider>
  );
};

export { ThemeProvider };
export default ThemeProvider;